<template>
  <div>
    <data-table :service="service"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                operations="refresh,add"
                disable-permission-checks
                :go-to-add-on-click="false"
                @on-add="openModal"
                ref="table">
      <template v-slot:client_name="{row}">
        <div class="d-flex align-items-center">
          <base-avatar :name="row.client_name">
          </base-avatar>
          <router-link v-if="row.client" class="ml-2 font-weight-bold" :to="getClientLink(row)" @click.native.stop="">
            {{row.client_name}}
          </router-link>
          <b v-else>
            &nbsp; {{row.client_name}}
          </b>
        </div>
      </template>

      <template v-slot:name="{row}">
        {{row.name || $t('generic.na')}}
      </template>

      <template v-slot:price_ex="{row}">
        <div class="flex flex-column">
          <div>
            {{parseFloat(row.price_ex) | toCurrency}}
            <small>{{$t('generic.exclVAT')}}</small>
          </div>
          <div class="mt-1">
            {{parseFloat(row.price_in) | toCurrency}}
            <small>{{$t('generic.inclVAT')}}</small>
          </div>
        </div>
      </template>

      <template v-slot:created_at="{row}">
        {{row.created_at ? $formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT) : $t('generic.na')}}
      </template>
      <template v-slot:date_sent="{row}">
        {{row.date_sent ? $formatDate(row.date_sent, FRIENDLY_DATETIME_FORMAT) : $t('generic.na')}}
      </template>
      <template v-slot:status="{row}">
        <status-badge v-slot:status="{row}" :status="row.status"/>
      </template>

      <template v-slot:extra-buttons="{row}">
        <base-button outline
                     icon
                     :loading="row.loading"
                     size="sm">
          <i class="far fa-eye"></i>
        </base-button>
      </template>
    </data-table>

    <modal :show.sync="showCreateModal">
      <h6 slot="header">{{$t('invoice.create.title')}}</h6>
      <form @submit.prevent="createInvoice">
        <fg-input :label="$t('invoice.edit.client')"
                  required
                  :error="getError($t('invoice.edit.client'))">
          <client-autocomplete v-model="selectedClient"
                               :allow-create="false"
                               :name="$t('invoice.edit.client')"
                               :searchParams="clientSearchParams"
                               v-validate="'required'">
          </client-autocomplete>
          <small slot="infoBlock">
            {{$t('invoice.create.createTip')}}
          </small>
        </fg-input>
        <div class="flex w-full justify-center">
          <submit-button :loading="loading" native-type="submit"/>
        </div>
      </form>
    </modal>
  </div>
</template>
<script>
  import entities from 'src/config/entities'
  import InvoiceService from 'src/services/InvoiceService'
  import ClientAutocomplete from 'src/components/Autocomplete/ClientAutocomplete'
  import Modal from 'src/components/Modal'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'invoice-list',
    components: {
      ClientAutocomplete,
      Modal
    },
    props: {
      filters: {
        type: Array,
        default: () => [
          {
            key: 'with',
            value: 'client'
          }
        ]
      }
    },
    data () {
      return {
        entity: entities.INVOICE,
        service: InvoiceService,
        FRIENDLY_DATETIME_FORMAT,
        selectedClient: null,
        showCreateModal: false,
        loading: false,
        clientSearchParams: {
          with: 'addresses',
        }
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'client_name',
            label: this.$t('invoice.list.labels.client'),
            minWidth: '190px',
            sortable: true
          },
          {
            prop: 'name',
            label: this.$t('invoice.list.labels.name'),
            minWidth: '140px',
            sortable: true
          },
          {
            prop: 'status',
            label: this.$t('invoice.list.labels.status'),
            minWidth: '120px',
            sortable: true,
            align: 'center'
          },
          {
            prop: 'price_ex',
            label: this.$t('invoice.list.labels.priceEx'),
            minWidth: '200px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '175px',
            sortable: true
          },
        ]
      }
    },
    methods: {
      getError (name) {
        return this.errors.first(name)
      },
      getClientLink(row) {
        if(row.client) {
          return `/contacts/clients/${row.client.uuid}`;
        }
        return this.$route.fullPath;
      },
      openModal () {
        this.showCreateModal = true
      },
      onClientChange (client) {
        this.selectedClient = client
      },
      async createInvoice () {
        try {
          let res = await this.$validator.validateAll()
          if (!res) {
            return
          }
          this.loading = false
          await InvoiceService.generateInvoiceForClient(this.selectedClient.uuid)
          this.showCreateModal = false
          this.$refs.table.refresh()
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>
<style>
</style>
